import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import {
  SUBCONTRACTORS_RECORDS_VIEW,
  WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS,
} from 'scenes/Permissions/constants/permissions';
import { selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness } from 'scenes/Permissions/store/selectors/personalPermissionsSelectors';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { setWorkSearchParams } from '../actions/demoActions';
import { selectIsPersonalWorkCalendarMode } from '../selectors/base-work-calendar.selectors';
import { selectWorkSearchStateFromDateAndToDate } from '../selectors/workSearchParamsSelectors';
import { selectIsActiveSearchFilters } from '../selectors/workSelectorsDemo';
import { loadAdminCalendarDataInTimeframeWithSearchParams } from './loadAdminCalendarDataInTimeframeWithSearchParams.thunk';
import { loadAdminCalendarFilesDataInTimeframe } from './loadAdminCalendarFilesDataInTimeframe.thunk';
import { loadAdminCalendarRecordsDataInTimeframe } from './loadAdminCalendarRecordsDataInTimeframe.thunk';
import { loadCalendarDataInTimeframe } from './loadCalendarDataInTimeframe.thunk';
import { loadSubcontractorRecordsData } from './loadSubcontractorRecordsData.thunk';
import { loadWorkCalendarWorkTimeSaldoInformationInTimeframe } from './loadWorkCalendarWorkTimeSaldoInformationInTimeframe.thunk';
import { loadPersonalWorkCalendarData } from './my-lixani/loadPersonalWorkCalendarData.thunk';

export const searchWorkCalendar = createAsyncThunk(
  'project/searchWorkCalendar',
  async (_, { dispatch, getState }) => {
    const state = getState();

    const isPermissionFromActiveEmployerToViewAllBusinessRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        WORK_CALENDAR_VIEW_ALL_OWN_BUSINESS_RECORDS
      );

    const componentStateDates = selectWorkSearchStateFromDateAndToDate(state);

    const isPersonalWorkCalendarMode = selectIsPersonalWorkCalendarMode(state);

    const isPermissionFromActiveBusinessToViewSubcontractorRecords =
      selectIsRequiredBusinessPermissionFromCurrentActiveEmployerBusiness(
        getState(),
        SUBCONTRACTORS_RECORDS_VIEW
      );

    const selectedProject = selectSelectedProject(getState());

    const activeEmployerBusinessId =
      selectUserActiveEmployerBusinessId(getState());

    dispatch(
      setWorkSearchParams({
        fromDate: dayjs(componentStateDates.fromDate)
          .startOf('day')
          .utcOffset(0)
          .format(),
        toDate: dayjs(componentStateDates.toDate)
          .endOf('day')
          .utcOffset(0)
          .format(),
      })
    );

    dispatch(loadWorkCalendarWorkTimeSaldoInformationInTimeframe());

    const isActiveSearchFilters = selectIsActiveSearchFilters(state);

    if (isPersonalWorkCalendarMode) {
      await dispatch(loadPersonalWorkCalendarData());
    } else {
      if (
        isPermissionFromActiveEmployerToViewAllBusinessRecords &&
        activeEmployerBusinessId === selectedProject.business_id
      ) {
        if (isActiveSearchFilters) {
          await dispatch(loadAdminCalendarDataInTimeframeWithSearchParams());
        } else {
          await Promise.allSettled([
            dispatch(loadAdminCalendarRecordsDataInTimeframe()),
            dispatch(loadAdminCalendarFilesDataInTimeframe()),
          ]);
        }
      } else {
        if (isPermissionFromActiveBusinessToViewSubcontractorRecords) {
          await Promise.allSettled([
            dispatch(loadCalendarDataInTimeframe()),
            dispatch(loadSubcontractorRecordsData()),
          ]);
        } else {
          await dispatch(loadCalendarDataInTimeframe());
        }
      }
    }
  }
);
